import {StoreDataType} from "shared/utilities/Store/StoreBase";
import {FBRowOptions} from "FormBuilder/Core/FBRow.Options";
import {FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {FBFieldWithPriceBaseOptions} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";

export class FBRepeaterItemOptions extends FBFieldWithPriceBaseOptions{

    public Label;
    @StoreDataType(FBRowOptions)
    public Rows:FBRowOptions[];
    public ShowSubTotal:boolean;
    public SubTotalLabel:string;


    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Label='List';
        this.Type=FieldTypeEnum.RepeaterItem;
        this.Rows=[];
        this.IsFieldContainer=true;
        this.ShowSubTotal=false;
        this.SubTotalLabel='Subtotal';
    }

}